var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3536_145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 0H6.11111C5.19097 0 4.44097 0.851563 4.47569 1.88281C4.48264 2.08984 4.48958 2.29688 4.5 2.5H0.833333C0.371528 2.5 0 2.91797 0 3.4375C0 7.05469 1.16319 9.57031 2.72569 11.2773C4.26389 12.9609 6.13889 13.8086 7.52083 14.2383C8.33333 14.4922 8.88889 15.2539 8.88889 16.0195C8.88889 16.8359 8.29861 17.5 7.57292 17.5H6.66667C6.05208 17.5 5.55556 18.0586 5.55556 18.75C5.55556 19.4414 6.05208 20 6.66667 20H13.3333C13.9479 20 14.4444 19.4414 14.4444 18.75C14.4444 18.0586 13.9479 17.5 13.3333 17.5H12.4271C11.7014 17.5 11.1111 16.8359 11.1111 16.0195C11.1111 15.2539 11.6632 14.4883 12.4792 14.2383C13.8646 13.8086 15.7396 12.9609 17.2778 11.2773C18.8368 9.57031 20 7.05469 20 3.4375C20 2.91797 19.6285 2.5 19.1667 2.5H15.5C15.5104 2.29688 15.5174 2.09375 15.5243 1.88281C15.559 0.851563 14.809 0 13.8889 0ZM1.69792 4.375H4.62847C4.94444 7.89453 5.64236 10.2461 6.43056 11.8203C5.56597 11.3906 4.66667 10.7852 3.88889 9.93359C2.77778 8.71875 1.875 6.96484 1.70139 4.375H1.69792ZM16.1146 9.93359C15.3368 10.7852 14.4375 11.3906 13.5729 11.8203C14.3611 10.2461 15.059 7.89453 15.375 4.375H18.3056C18.1285 6.96484 17.2257 8.71875 16.1181 9.93359H16.1146Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3536_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophySolid);
export default __webpack_public_path__ + "static/media/trophy-solid.d5a6146f22a7008ac61a696912004ab1.svg";
export { ForwardRef as ReactComponent };